import React from 'react';
interface ServicePlanProps {
  title: string;
  price: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  buttonLink: string;
}
const ServicePlan = ({
  title,
  price,
  description,
  imageUrl,
  imageAlt,
  buttonLink
}: ServicePlanProps) => {
  return <div className="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-[1.02]" data-id="element-141">
      <div className="h-48 overflow-hidden" data-id="element-142">
        <img src={imageUrl} alt={imageAlt} className="w-full h-full object-cover" data-id="element-143" />
      </div>
      <div className="p-6 flex-grow flex flex-col" data-id="element-144">
        <h3 className="text-xl font-bold text-[#1a3a6c] mb-2" data-id="element-145">{title}</h3>
        <p className="text-2xl font-bold text-[#f97316] mb-4" data-id="element-146">{price}</p>
        <p className="text-gray-600 mb-6 flex-grow" data-id="element-147">{description}</p>
        <a href={buttonLink} target="_blank" rel="noopener noreferrer" className="bg-[#3b82f6] text-white text-center py-3 px-4 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors" data-id="element-148">
          Purchase Plan
        </a>
      </div>
    </div>;
};
export default ServicePlan;